import React, { useCallback } from 'react';
import { useTranslation }     from 'react-i18next';

import ClearIcon          from '../icons/ClearIcon';
import bookmarksConstants from '../../providers/bookmarks/bookmarks.constants';
import RenderButton       from './base/RenderButton';
import { useBookmarks }   from '../../providers/bookmarks';

const ClearBookmarks = function() {
  const { t }         = useTranslation();
  const { showModal } = useBookmarks();

  const onClick = useCallback(() => {
    showModal(bookmarksConstants.SHOW_MODAL);
  }, [showModal]);

  return (
    <RenderButton
      action={onClick}
      className={'clear_bookmarks_btn'}
      label={
        <>
          <ClearIcon />
          {t('btn_deleted_all_bookmarks')}
        </>
      }
    />
  );
};

export default ClearBookmarks;
